import { useTheme } from "@/src/styles/theme-provider";
import { CloseCircle, Danger, TickCircle } from "iconsax-react-nativejs";
import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

export type ScToastProps = Readonly<{
  text1: string;
  type: "success" | "error";
  onClose: () => void;
}>;

const ScToast = ({ text1, type, onClose }: ScToastProps) => {
  const { t } = useTranslation();
  const { themeVars, varStyle } = useTheme();
  const isSuccess = type === "success";

  const textColor = isSuccess ? "text-green-light" : "text-crimson";

  return (
    <View
      style={varStyle}
      className="mx-4 mt-4 rounded-[16px] bg-ash px-6 py-4 flex-row items-center gap-3 shadow-md border border-ash-3"
    >
      {isSuccess ? (
        <TickCircle
          size={24}
          color={themeVars["--color-primary-default"]}
          variant="Bold"
        />
      ) : (
        <Danger
          size={24}
          color={themeVars["--color-crimson-default"]}
          variant="Bold"
        />
      )}

      <Text className={`flex-1 font-medium ${textColor}`}>{t(text1)}</Text>

      <Pressable
        onPress={onClose}
        hitSlop={10}
        className="p-1.5 rounded-full hover:bg-ash-3"
      >
        <CloseCircle size={20} color={themeVars["--color-slate-default"]} />
      </Pressable>
    </View>
  );
};

export default ScToast;
